export default __webpack_public_path__ + "static/media/curiosity-people.f5a9f3be.png";